import { type ComponentProps, createElement } from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { PillStyled } from '@core/Components/Pill'
import { Text } from '@core/Components/Text'

const RaceContentTextBase = styled(Text)({
  lineHeight: 'inherit',
  margin: 0,
})

export const RaceContentTextStyled = ({
  as = 'p',
  size = 'sm',
  ...props
}: ComponentProps<typeof RaceContentTextBase>) =>
  createElement(RaceContentTextBase, { as, size, ...props })

export const RaceContentBadgeStyled = styled(PillStyled)(() => ({
  background: hexColors.black,
  color: hexColors.white,
  padding: '0.1rem 0.8rem',
  marginLeft: '0.5rem',
}))

export const RaceContentContainerStyled = styled.div({
  display: 'flex',
  gap: '1rem',
})
